<template>
<div class="chapter">
<div class="inner_page">
<div>
<div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-10">Ghost Hunter’s Guide</p>
</div>
<div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-1">to</span></p>
<p class="Basic-Paragraph para-style-override-11"></p>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-12">Portland</p>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-13">and the</p>
</div>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-12">Oregon Coast</p>
</div>
</div>
<div class="Basic-Text-Frame">
<p class="Basic-Paragraph para-style-override-11a">Jeff Dwyer</p>
<div class="frame-2a"><img alt="PELOGO.TIF" class="frame-3" src="Images/PELOGO_fmt.jpeg" style="width: 80.46875px;"/></div>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph"></p>
<p class="Basic-Paragraph para-style-override-2"><span class="char-style-override-3">PELICAN PUBLISHING COMPANY</span></p>
<p class="Basic-Paragraph para-style-override-3"><span class="char-style-override-5">Gretna 2015</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?391badda